import { inject, Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    MaybeAsync,
    Resolve,
    RouterStateSnapshot,
} from '@angular/router';
import { ApiService } from './api.service';
import { catchError, of } from 'rxjs';
import { CartService } from './cart.service';

@Injectable({ providedIn: 'root' })
export class PageResolver implements Resolve<any> {
    private apiService: ApiService = inject(ApiService);
    private cartService: CartService = inject(CartService);

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): MaybeAsync<any> {
        let languageCode = route.params['languageCode'];
        if (languageCode !== 'de' && languageCode !== 'en') {
            languageCode = 'de';
        }
        let slug = route.params['slug'];
        if (route.url.length >= 3) {
            slug = `${route.url[1]}/${slug}`;
        }

        if (slug === 'hof/success') {
            this.cartService.clearCart();
        }

        return this.apiService.getPageBySlugGraphql(slug, languageCode).pipe(
            catchError(() => {
                return of({ data: { pages: [] } });
            }),
        );
    }
}
